// メール再送の部品
import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import Heading from './Heading';
import Text from './Text';
import { number_symbol } from '../Const';

interface Props {
  value: { [key: string]: string };
  number: number;
  message: { [key: string]: string };
  handleClick: (value: { [key: string]: string }, no: number) => void;
}

const MailResendBox: React.FC<Props> = ({ value, number, message, handleClick }) => {
  const [state, setState] = useState(value);
  const [text, setText] = useState('メールを再送する');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setState({ ...state, email: event.target.value });
    setText('メールアドレスを更新して再送する');
  };

  return (
    <>
      <Heading label={`連帯債務者等${number_symbol[number]}`} size="s" />
      <div>
        <Text
          id={`guarantors${number}_name`}
          label="お名前"
          value={state.name}
          placeholder=""
          handleChange={() => {}}
          disabled={true}
          looks_inactive={true}
        />
        <Text
          id={`guarantors${number}_mail`}
          label="メールアドレス"
          value={state.email}
          placeholder=""
          handleChange={handleChange}
          disabled={false}
          message={message[number]}
          looks_inactive={false}
          display_border={true}
        />
      </div>
      <div className="center-button my-3">
        <Button
          size="lg"
          variant="green"
          className="mail-resend-button"
          onClick={() => handleClick(state, number)}
        >
          {text}
        </Button>
      </div>
    </>
  );
};
export default MailResendBox;
